import Vue3ConfirmDialog from 'vue3-confirm-dialog'
import 'vue3-confirm-dialog/style'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('vue3-confirm-dialog', Vue3ConfirmDialog.default)
  nuxtApp.vueApp.use(Vue3ConfirmDialog)
})
